import React, { Suspense } from "react";

import { Outlet } from "react-router-dom";
import { Header } from "views/components";
import SideBar from "views/components/sidebar";

const PrivateLayout = () => {
  return (
    <>
      <div className="flex h-screen">
        <Suspense>
          <SideBar />
          <div className="dashboar-content w-full">
            <Header />
            <Suspense>
              <main className="dashboar-wrap">
                <Outlet />
              </main>
            </Suspense>
          </div>
        </Suspense>
      </div>
    </>
  )
}
export default PrivateLayout